module.exports = __webpack_public_path__ + "static/media/kartik_mandhan.32c07779.jpg";